<template>
    <div class="q_list" @mouseup.stop="changeActiveEditor" @focusin.stop="changeActiveEditorFromFocus">
        <template
            v-for="agreement in agreements">
            <div class="agreement_item"
                 :key="`agreement-${agreement.questionNo}`">
                <div class="agreement_title">
                    {{agreement.question}}
                    <span :style="{color:'#ff5c5c'}" v-if="agreement.isRequired">(필수)</span>
                </div>
                <div class="agreement_desc" v-html="agreement.questionDesc"/>
            </div>
        </template>
        <button type="button" class="btn_edit">{{$t('EnrolmentQuestionViewer_edit')}}</button>
    </div>
</template>

<script>
import whatInput from 'what-input';

export default {
    name: 'EnrolmentAgreementViewer',

    computed: {
        agreements() {
            return this.$store.state.enrolment.form.agreements
                       .map(question => {
                               return {
                                   questionNo: question.questionNo,
                                   question: question.question || this.$t('EnrolmentAgreementItemEditor_inputAgreementTitle'),
                                   questionDesc: question.questionDesc || this.$t('EnrolmentAgreementItemEditor_inputAgreementDesc'),
                                   mandatory: question.mandatory || false,
                               };
                           },
                       );
        },
    },

    methods: {
        changeActiveEditorFromFocus() {
            if (whatInput.ask() !== 'keyboard') {
                return;
            }

            this.$emit('changeActiveEditor');
        },

        changeActiveEditor() {
            this.$emit('changeActiveEditor');
        },
    },
};
</script>

<style scoped lang="scss">
.agreement_title {
    max-width: 550px;
    display: inline-block;
    font-size: 17px;
    font-weight: 700;
    margin-bottom: 16px;
}

.agreement_desc {
    padding: 20px;
    background: #fff;
    border: 1px solid #e6e8eb;
    white-space: break-spaces;
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.5px;
}


.agreement_item:not(:first-child) {
    margin-top: 24px;
}
</style>
